import api from "../../../api/analyses/activations";

export const getActivation = ({ commit, getters }) => {
    api.getSingleAudience({
        audience: getters.getAudienceId
    }).then(res => {

        commit('SET_DESCRIPTION', res.data.activation.name + ' Activation')

        commit('SET_ACTIVATION', res.data.activation)
        commit('SET_AUDIENCE', parseInt(res.data.activation.resultsCount))

        let analyses = []
        res.data.activation.dataset.forEach(item => {
            analyses.push(item.analysistype.toLowerCase())
        })
        commit('SET_ACTIVATION_ANALYSES', analyses)

        if (res.data.activation.freqResults.length) {
            commit('SET_RANGE_MIN_AND_MAX', {
                results: res.data.activation.freqResults,
                type: 'frequency'
            })

            commit('CALCULATE_TOTAL_VISITS')
        }

        if (res.data.activation.distanceResults.length) {
            commit('SET_RANGE_MIN_AND_MAX', {
                results: res.data.activation.distanceResults,
                type: 'distance'
            })

            commit('CALCULATE_TOTAL_VISITS_BY_DISTANCE')
        }
    })
}

export const getActivationPartners = ({ commit, getters }) => {
    api.getEndpointPartners()
        .then(res => {
            let partners = []
            res.data.forEach( item => {
                if(item.permissions) {
                    getters.getActivationAnalyses.forEach( analysis => {
                        if (item.permissions.includes(analysis)) {
                            if (!partners.includes(item)) {
                                partners.push(item)
                            }
                        }
                    })
                }
            })

            commit('SET_ACTIVATION_ENDPOINTS', partners)
        })
}

export const getEndpointPricingModels = ({ commit, getters }) => {
    api.getPricingModelsByActivationPartner({
        partner_id: getters.getActivationPartner.id,
        analyses: getters.getActivationAnalyses
    }).then(res => {
        let pricing_models = []
        let pricing_models_data = []
        res.data.forEach(model => {
            if (model.analyses.some(item => getters.getActivationAnalyses.includes(item))) {
                let text = model.label + ' - $' + model.price.toFixed(3)
                let value = model.id

                pricing_models.push({'text': text, 'value': value})

                pricing_models_data.push(model)
            }
        })

        commit('SET_PRICING_MODELS', pricing_models)
        commit('SET_PRICING_MODELS_DATA', pricing_models_data)
    })
}

export const getDataStreams = ({ commit, getters }) => {
    commit('SET_DATASTREAMS_LOADING_COMPLETED', false)

    api.getDataStreams({
        analyses: getters.getActivationAnalyses,
        pricing_model: getters.getPricingModel,
        endpoint: getters.getActivationPartner.id
    })
        .then(res => {
            let tmp_datastreams = []
            let tmp_inputs = []
            res.data.forEach( item => {
                if(item.permissions) {
                    getters.getActivationAnalyses.forEach( analysis => {
                        if (item.permissions.includes(analysis) && !tmp_datastreams.some(tmp_item => {
                            if (tmp_item.value === item.value) {
                                return true
                            }
                            return false
                        })) {
                            if (getters.getActivationPartner.is_data_streaming_allowed || item.is_default) {
                                tmp_datastreams.push({
                                    text: item.text,
                                    value: item.value,
                                    description: item.description,
                                    is_default: !!item.is_default,
                                    is_visualizing_available: item.is_visualizing_available
                                })

                                let ds_service_account = null
                                let ds_service_account_file = null
                                if (getters.getAudienceServiceAccount && Object.keys(getters.getAudienceServiceAccount).length) {
                                    ds_service_account = getters.getAudienceServiceAccount
                                    ds_service_account_file = getters.getAudienceServiceAccountFile
                                }
                                tmp_inputs.push({
                                    id: item.value,
                                    name: item.text,
                                    status: false,
                                    compression: getters.getAudienceCompressionType,
                                    inputs: setFolderPrefixOnDataStream(item, getters.getAudienceInputs, getters.getActivationPartner.inputs),
                                    service_account: ds_service_account,
                                    service_account_file: ds_service_account_file,
                                    custom_delivery: setFolderPrefixMacros(item, getters.getAudienceInputs, getters.getActivationPartner.inputs),
                                    visualizing_status: false
                                })
                            }
                        }
                    })

                }
            })
            commit('SET_DATASTREAMS_OPTIONS', tmp_datastreams)
            commit('SET_DATASTREAMS_INPUTS', tmp_inputs)

            tmp_datastreams.forEach((data_stream, ds_index) => {
                if (data_stream.is_default) {
                    commit('SET_DATASTREAMS_STATUS_BY_INDEX', {
                        data_stream: ds_index,
                        value: true
                    })
                }
            })

            commit('SET_DATASTREAMS_LOADING_COMPLETED', true)
        })
}

export const closeModal = ({ commit }) => {
    commit('RESET_STATE')
    commit('SET_MODAL', false)
}

function setFolderPrefixMacros(data_stream, audience_inputs, partner_inputs) {
    let custom_delivery = {
        is_custom_delivery: false,
        custom_macros: []
    }
    audience_inputs.forEach((input, index) => {
        if (partner_inputs[index].name === 'Folder Prefix' && data_stream.is_custom_delivery) {
            custom_delivery.is_custom_delivery = data_stream.is_custom_delivery
            custom_delivery.custom_macros = data_stream.custom_macros
        }
    })

    return custom_delivery
}

function setFolderPrefixOnDataStream(data_stream, audience_inputs, partner_inputs) {

    let data_stream_inputs = {}
    audience_inputs.forEach((input, index) => {
        if (partner_inputs[index].name === 'Folder Prefix') {
            let new_folder_prefix = input
            if (!input.endsWith("/")) {
                new_folder_prefix = new_folder_prefix + "/"
            }
            new_folder_prefix = new_folder_prefix + stringToSlug(data_stream.text) + "/"
            data_stream_inputs[index] = new_folder_prefix

        } else {
            data_stream_inputs[index] = input
        }
    })

    return data_stream_inputs
}

const stringToSlug = str =>
    str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '_')
        .replace(/^-+|-+$/g, '');

export const increaseProcessStep = ({ commit, getters }) => {
    let current_step = getters.getCurrentStep
    let new_step = current_step + 1
    commit('SET_STEP', new_step)
}

export const decreaseProcessStep = ({ commit, getters }) => {
    let current_step = getters.getCurrentStep
    let new_step = current_step - 1
    commit('SET_STEP', new_step)
}
